// extracted by mini-css-extract-plugin
export var activityContainer = "_mi-0";
export var typingIndicatorContainer = "_mi-1";
export var typingIndicatorDot = "_mi-2";
export var wave = "_mi-3";